import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCalculatedSuggestion } from "./api";
import { ISuggestions, ISuggestionsRequest } from "./model";
import { RootState } from "../RootState";

export const getSuggestedCalc = createAsyncThunk<
    ISuggestions,
    ISuggestionsRequest,
    {
        state: RootState;
    }
>('shoping_car/getSuggestedCalc', async (payload, thunkAPI) => {
    const store: RootState = thunkAPI.getState();
    const { token } = store.User; 
    return getCalculatedSuggestion(payload, token);
});
